import React from 'react';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import tz from 'dayjs/plugin/timezone';
import { TEMPLATE_OPTIONS } from '../../Configuration/Events/components/MessageComposer';

dayjs.extend(utc);
dayjs.extend(tz);

export const TEMPLATE_REGEX = new RegExp(
  `(${TEMPLATE_OPTIONS.map(t => t.value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|')})`,
  'g',
);

export const formatMessagePreview = text => {
  if (!text) return '—';
  const parts = text.split(TEMPLATE_REGEX);
  const result = [];
  parts.forEach(part => {
    const opt = TEMPLATE_OPTIONS.find(t => t.value === part);
    if (opt) {
      result.push(
        <span key={`${opt.value}-${result.length}`} className="ant-tag-clientbook">
          {opt.label}
        </span>,
      );
    } else {
      result.push(part);
    }
  });
  return result;
};

export const formatDateTime = (val, timezone) => {
  if (!val) return null;
  const d = timezone ? dayjs(val).tz(timezone) : dayjs(val);
  return d.format('D MMM YYYY [at] h:mma z');
};
